import { Button, ButtonType, TextInput } from '@resurs-internal/styx-react'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '../common/utils'
import styles from './Mock.module.scss'

const proxyPath = process.env.REACT_APP_RETAIL_FINANCE_MOCK_PROXY_PATH

export const CheckpointBankIdMock = () => {
  const { token } = useParams()
  const { authType, signerIndex } = useQuery()
  const [govId, setGovId] = useState('')
  const [govIdHidden, setGovIdHidden] = useState(false)
  const [session, setSession] = useState(null)
  const [done, setDone] = useState(false)
  const [doneSuccess, setDoneSuccess] = useState(false)

  const isSigning = authType === 'sign'

  useEffect(() => {
    fetch(`${proxyPath}/checkpoint-bankid-mock/${authType}/${token}/session`, {
      headers: { Accept: 'application/json' },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (!data) return
        setSession(data)
        if (!isSigning && data.governmentId) {
          setGovId(data.governmentId)
          setGovIdHidden(true)
        }
        if (data.status && !['PENDING', 'CREATED'].includes(data.status)) {
          setDoneSuccess(['COMPLETED', 'COMPLETE'].includes(data.status))
          setDone(true)
        }
      })
      .catch(console.error)
  }, [authType, token])

  const doComplete = () => {
    let url = `${proxyPath}/checkpoint-bankid-mock/${authType}/doComplete?token=${encodeURIComponent(token)}`
    if (!isSigning && govId) url += `&govId=${encodeURIComponent(govId)}`
    if (isSigning && signerIndex != null)
      url += `&signerIndex=${encodeURIComponent(signerIndex)}`
    window.location.href = url
  }

  const doCancel = () => {
    let url = `${proxyPath}/checkpoint-bankid-mock/${authType}/doCancel?token=${encodeURIComponent(token)}`
    if (isSigning && signerIndex != null)
      url += `&signerIndex=${encodeURIComponent(signerIndex)}`
    window.location.href = url
  }

  if (done) {
    return (
      <>
        <h1>
          {doneSuccess
            ? isSigning
              ? 'Signing complete'
              : 'Identification complete'
            : 'Cancelled'}
        </h1>
        <p>
          {doneSuccess
            ? 'The operation completed successfully.'
            : 'The operation was cancelled.'}
        </p>
      </>
    )
  }

  return (
    <>
      <h1>{isSigning ? 'Sign with BankID' : 'Identify with BankID'}</h1>
      <p>hos Resurs Bank</p>

      {isSigning && session?.documentText && (
        <div className={styles.documentText}>{session.documentText}</div>
      )}

      {isSigning && session?.signers?.length > 0 && (
        <div className={styles.infoSection}>
          <div className={styles.sectionLabel}>Signers</div>
          {session.signers.map(s => (
            <div key={s.governmentId || s.name} className={styles.listItem}>
              <span>{s.name || 'Unknown'}</span>
              {s.governmentId && (
                <span className={styles.meta}>({s.governmentId})</span>
              )}
              <span className={styles.meta}>[{s.status}]</span>
            </div>
          ))}
        </div>
      )}

      {!isSigning && !govIdHidden && (
        <div className={styles.lineWrapper}>
          <TextInput
            id="govId"
            label="Personnummer"
            value={govId}
            onChange={(_, value) => setGovId(value)}
          />
        </div>
      )}

      <div className={styles.lineWrapper}>
        <Button id="actionBtn" fullWidth onClick={doComplete}>
          {isSigning ? 'Signera' : 'Identifiera'}
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="cancelBtn"
          type={ButtonType.Secondary}
          fullWidth
          onClick={doCancel}
        >
          Avbryt
        </Button>
      </div>
    </>
  )
}
